export const CREATE_NEW = '@CREATE_NEW'
